const getUnscheduledBreaksWarningForShift = (shift) => {
    if (!shift || !shift.breaks || !shift.breaks.length || shift.status === 'DELETED') {
        return null;
    }

    for (const breakItem of shift.breaks) {
        if (!breakItem.start_time) {
            return {
                code: 'UNSCHEDULED_BREAKS'
            };
        }
    }

    return null;
}

const getUnscheduledBreaksWarning = (usersShifts) => {
    const warnings = [];
    
    if (!usersShifts || !usersShifts.length) {
        return warnings;
    }

    for (const shift of usersShifts) {
        const shiftWarning = getUnscheduledBreaksWarningForShift(shift);
        if (shiftWarning) {
            warnings.push(shiftWarning);
        }
    }

    return warnings;
}

export const UnscheduledBreaksWarningUtil = {
    getUnscheduledBreaksWarning,
    getUnscheduledBreaksWarningForShift
}